export default __webpack_public_path__ + "static/media/info-circle.2aee8c23.svg";